var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-section"},[_c('ServiceOrders',{staticClass:"cms-section__container"}),_c('Alerts',{staticClass:"cms-section__container"}),_c('Discounts',{staticClass:"cms-section__container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }